__turbopack_context__.v({
  "body": "a8ETrG_body",
  "content": "a8ETrG_content",
  "copy": "a8ETrG_copy",
  "ctaSection": "a8ETrG_ctaSection",
  "desktopMedia": "a8ETrG_desktopMedia",
  "mobileMedia": "a8ETrG_mobileMedia",
  "scrim": "a8ETrG_scrim",
  "title": "a8ETrG_title",
  "titleMuted": "a8ETrG_titleMuted",
});
